export enum UnitSymbol {
  SquareMeter = 'm<sup>2</sup>',
  Pieces = 'St.',
  Percentage = '%',
  Euro = '€',
  Average = '&Oslash;'
}
